if (document.querySelector('.accordeon-item-title-js')) {
	const accordeonTitles = Array.from(document.querySelectorAll('.accordeon-item-title-js'));
	accordeonTitles.forEach((title) => {
		title.addEventListener('click', (e) => {
			const elementClasses = e.target.parentElement.classList;
			if (document.querySelector('.accordeon-item-open') &&
				document.querySelector('.accordeon-item-open') !== e.target.parentElement) {
				document.querySelector('.accordeon-item-open').classList.remove('accordeon-item-open');
			}
			if (elementClasses.contains('accordeon-item-open')) {
				elementClasses.remove('accordeon-item-open');
			} else {
				elementClasses.add('accordeon-item-open');
			}
		});
	});
}
